/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Pin_NoneInputs */



/**
* | output |
* | --- |
* | "Not pinned" |
*
* @param {Community_Pin_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_pin_none = /** @type {((inputs?: Community_Pin_NoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Pin_NoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non épinglé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin fijar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem fixar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non fissato")
	return /** @type {LocalizedString} */ ("Not pinned")
});